//Action Types
export var AVAILABLE_STAFF_RESET_ACTION_TYPE = "available_staff/reset";
export var AVAILABLE_STAFF_FETCH_START_ACTION_TYPE = "available_staff/available_fetch_staff_start";
export var AVAILABLE_STAFF_FETCH_SUCCESS_ACTION_TYPE = "available_staff/available_fetch_staff_success";
export var AVAILABLE_STAFF_UNAVAILABLE_START_ACTION_TYPE = "available_staff/unavailable_fetch_staff_start";
export var AVAILABLE_STAFF_UNAVAILABLE_SUCCESS_ACTION_TYPE = "available_staff/unavailable_fetch_staff_success";
export var AVAILABLE_STAFF_ERROR_ACTION_TYPE = "available_staff/error";
